var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3049_7846)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.06641,
    y: 1,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.41265,
    y: 1.34625,
    width: 27.3075,
    height: 27.3075,
    rx: 13.6538,
    stroke: "#D0D5DD",
    strokeWidth: 0.692494
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3049_7846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9915 14.9992C22.9915 11.1746 19.8911 8.07422 16.0665 8.07422C12.242 8.07422 9.1416 11.1746 9.1416 14.9992C9.1416 18.4555 11.6739 21.3205 14.9845 21.84V17.0009H13.2262V14.9992H14.9845V13.4735C14.9845 11.7379 16.0184 10.7793 17.6002 10.7793C18.3576 10.7793 19.1503 10.9145 19.1503 10.9145V12.6187H18.2771C17.4169 12.6187 17.1486 13.1526 17.1486 13.7007V14.9992H19.0692L18.7621 17.0009H17.1486V21.84C20.4591 21.3205 22.9915 18.4555 22.9915 14.9992Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7625 17.0009L19.0695 14.9992H17.1489V13.7008C17.1489 13.1531 17.4172 12.6187 18.2774 12.6187H19.1506V10.9145C19.1506 10.9145 18.3582 10.7793 17.6005 10.7793C16.0187 10.7793 14.9848 11.738 14.9848 13.4735V14.9992H13.2266V17.0009H14.9848V21.84C15.7018 21.9522 16.4319 21.9522 17.1489 21.84V17.0009H18.7625Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3049_7846",
    x: 0.0664062,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3049_7846"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3049_7846",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3049_7846"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.8499,
    height: 13.8499,
    fill: "white",
    transform: "translate(9.1416 8.07422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbI);
export default __webpack_public_path__ + "static/media/Fb-i.d7457bf7032021b25c0e37a001bb947f.svg";
export { ForwardRef as ReactComponent };